<template>
  <div class="separator"></div>
</template>
<style lang="scss" scoped>
@import "@/_css/variables";

.separator {
  display: block;
  height: 1px;
  background-color: $gray-500;
  margin: 10px 0px;
}
</style>
